export function getScreenOrientation(): 'portrait' | 'landscape' {
	const orientationType = screen.orientation?.type;

	if (orientationType) {
		return orientationType.startsWith('portrait') ? 'portrait' : 'landscape';
	}

	const legacyOrientation = window.orientation;

	if (legacyOrientation !== undefined) {
		return legacyOrientation === 0 || legacyOrientation === 180 ? 'portrait' : 'landscape';
	}

	return window.innerWidth > window.innerHeight ? 'landscape' : 'portrait';
}
